<template>
  <div class="main">
    <div class="item" v-for="(item, index) in msgList" :key="index">
      <div class="item-left">
        <i class="el-icon-message-solid" style="position:relative;">
          <span v-show="!item.msg_is_read" class="message-unread"></span>
        </i>
      </div>
      <div class="item-center">
        <div class="item-title">{{item.msg_title}}</div>
        <div class="item-content">{{item.msg_content}}</div>
      </div>
      <div style="margin-left:20px;">{{item.create_date | dateFilter("yyyy-MM-dd HH:mm")}}</div>
      <el-button size="small" type="primary" style="padding:5px;margin-left:5px" @click="ReadClick(item)">标记为已读
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      data: []
    };
  },
  computed: {
    ...mapState(["msgList"]),
  },
  methods: {
    ...mapMutations(["reloadMsg"]),
    ReadClick(item) {
      item.msg_is_read = true;
      var msgs = [];
      msgs.push(item);
      this.z_put("sys/api/msg/app", msgs).then(res => {
        //消息列表刷新
        this.msgList.splice(this.msgList.indexOf(item), 1);
      }).catch(res => { });
    },
  }
};
</script>

<style scoped>
.main {
  height: 500px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 10px;
  overflow-y: auto;
  box-sizing: border-box;
}
.item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  box-sizing: border-box;
  border-bottom: 1px dashed #ccc;
  flex-shrink: 0;
}
.item:hover {
  background-color: #fafafa;
}
.item-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  font-size: 18px;
}
.item-center {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.item-right {
  display: flex;
  flex-direction: column;
  width: 100px;
  justify-content: flex-end;
}
.item-title {
  font-weight: bold;
}
.item-content {
  font-size: 14px;
}
.tb-ct {
  flex: 1;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto;
}
.left {
  box-sizing: border-box;
  width: 250px;
  border: 1px solid #dedede;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.center-tbar {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}
.c-tbar {
  background: #eceff4;
  padding: 5px 20px;
  margin-bottom: 10px;
}
.center {
  width: 1000px;
  border: 1px solid #dedede;
  padding: 0px 20px;
  position: relative;
  overflow-y: auto;
}
.center-content {
  display: block;
  position: absolute;
  box-sizing: border-box;
  width: calc(100% - 40px);
  height: 100%;
}
.title {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.title-content {
  font-size: 16px;
  padding: 0 10px;
}
.message-unread {
  position: absolute;
  top: 0px;
  left: 10px;
  width: 8px;
  height: 8px;
  color: #fff;
  background: red;
  background-clip: padding-box;
  border-radius: 50%;
}
</style>
